export const projectData = [
	{
		title: "Marketplace Management System",
		description:
			"Lead frontend development for MMS, an internal platform used to manage marketplaces, products, orders and operational workflows. Built React/TypeScript features using React Query and reusable component libraries, supporting authenticated flows across marketplace, product and order management. Coordinated with backend engineers, UX and Product to define API contracts and streamline delivery.",
		skills: [
			"React",
			"TypeScript",
			"React Query",
			"Frontend Architecture",
			"API Contract Design",
			"Backend Support",
			"Authentication",
			"Team Leadership",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Preloved Rebrand & Modernisation",
		description:
			"Led the rebrand and rebuild of Preloved's main traffic-facing pages, delivering frontend and backend integration work to modernise the user experience, improve performance, and increase maintainability. The project helped reverse declining traffic trends and reduced technical debt by replacing legacy implementations.",
		skills: [
			"React",
			"Performance Optimisation",
			"UX Collaboration",
			"Backend Integrations",
			"Codebase Modernization",
			"Frontend Development",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Custom AI Agent Framework",
		description:
			"Appointed AI Champion and developed a custom AI agent framework supporting high-level and repository-level agents. Implemented self-correcting workflows and internal tooling to reduce manual iteration, improve code quality and accelerate development cycles.",
		skills: [
			"AI Tooling",
			"Custom Agents",
			"Developer Productivity",
			"Automation",
			"Repository Management",
			"CI/CD",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Preloved Platform Ownership",
		description:
			"Served as sole maintainer for the Preloved estate in maintenance mode — primary responder for incidents, vulnerability remediation, patching, and long-term fixes. Focused on root-cause resolution to reduce recurring support overhead and improve platform stability.",
		skills: [
			"Incident Response",
			"Vulnerability Management",
			"Patching",
			"On-call Support",
			"Dependency Management",
			"Monitoring",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Active-Passive Failover Automation",
		description:
			"Automated the failover process for an active-passive application setup, reducing manual operational effort and improving incident response speed by codifying failover steps and checks.",
		skills: [
			"Automation",
			"High-Availability",
			"Runbooks",
			"Infrastructure",
			"CI/CD Compatibility",
			"Scripting",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Ezoic & Humix Integrations",
		description:
			"Implemented Ezoic integrations (initial proxy via CNAME, later JavaScript-based) and integrated Humix video functionality to support additional content and monetisation. Adapted frontend implementations to support ad displays and assessed performance impact.",
		skills: [
			"Ad Integration",
			"Ezoic",
			"Frontend Adaptation",
			"Performance Testing",
			"Display Ad Optimization",
			"Revenue Maximization",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Vulnerability & Security Management",
		description:
			"Managed vulnerability remediation across legacy and modern services, handling patching, dependency updates and long-term fixes to reduce security risk across the estate.",
		skills: [
			"Security Maintenance",
			"Dependency Management",
			"Patch Management",
			"Repository Security",
			"Vulnerability Remediation",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Legacy to Modern Migration",
		description:
			"Oversaw and assisted two contractors in migrating a component from Java, Handlebars, and Vanilla JavaScript to a modern React and Node.js framework. This effort simplified and improved the codebase, aligning it with the latest technologies and best practices. Provided domain knowledge and supported backend integration throughout the process.",
		skills: [
			"React",
			"Node.js",
			"Java",
			"Vanilla JavaScript",
			"Handlebars",
			"Backend Development",
			"Codebase Modernization",
			"Team Leadership",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "SendGrid Email Automation",
		description:
			"Automated Preloved newsletter sign-ups by integrating with SendGrid, a third-party email client, to reduce manual workload for cross-functional teams. Developed the new service using Java 21 and SpringBoot to manage this process efficiently.",
		skills: [
			"Java",
			"Spring Boot",
			"REST API Development",
			"Third-Party API Integration",
			"Email Automation",
			"Workflow Optimization",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Ezoic Ads Proxy Setup",
		description:
			"Integrated Ezoic, a third-party ad provider, as a proxy for Preloved using CNAMEs to enhance display ad revenue. Adapted the frontend to ensure proper ad display and functionality. Conducted performance tests to assess the impact of the integration and continuously optimized it for improved results.",
		skills: [
			"Frontend Adaptation",
			"Display Ad Optimization",
			"Performance Testing",
			"Third-Party Proxy Configuration",
			"Revenue Maximization",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "CentOS7 to Rocky9 Migration",
		description:
			"Contributed to migrating Preloved services from CentOS 7 to Rocky9 VMs, maintaining application stability throughout. Assisted in transitioning deployment pipelines from GoCD to Jenkins due to CICD incompatibility with Rocky9, ensuring a seamless migration and uninterrupted functionality.",
		skills: [
			"Linux Systems",
			"VM Management",
			"Pipeline Migration (GoCD to Jenkins)",
			"Application Deployment",
			"System Compatibility Testing",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Predictive Search Optimisation",
		description:
			"Optimized Preloved’s search functionality using ElasticSearch and SpringBoot (Java), implementing a feature to aggregate and store type-ahead suggestions. This enhancement led to a nearly 40% increase in user engagement, specifically among users upgrading to respond to ads.",
		skills: [
			"ElasticSearch",
			"Spring Boot",
			"Search Performance Optimisation",
			"Data Aggregation",
			"User Engagement Metrics",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "GitLab to GitHub Migration",
		description:
			"Contributed to migrating all Preloved components from GitLab to GitHub, modifying repositories to secure sensitive information across various tech stacks. Ensured GitHub repositories were fully compatible with GoCD for seamless application deployment.",
		skills: [
			"GitLab",
			"GitHub",
			"Repository Security",
			"CI/CD Compatibility",
			"Version Control",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Display Ad Development",
		description:
			"Developed and integrated new display ads using Google AdSense for Preloved, focusing on anchor ads. Successfully implemented these ads within the Preloved frontend using React, Handlebars, and ColdFusion.",
		skills: [
			"Google AdSense",
			"React",
			"Handlebars",
			"ColdFusion",
			"Anchor Ad Integration",
			"Frontend Development",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Archived Ads Resolution",
		description:
			"Resolved issues with ElasticSearch that caused archived customer ads to be incorrectly displayed on the platform, leading to inaccessible content. The resolution significantly improved the customer experience by eliminating false positives and ensuring only relevant ads were shown.",
		skills: [
			"ElasticSearch Cleanup",
			"Spring Boot",
			"Database Management",
			"Issue Debugging",
			"Customer Experience Improvement",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Line Management and Mentorship",
		description:
			"Served as a line manager, mentoring junior engineers by developing their skills and guiding them through challenges. Collaborated with and indirectly managed contractors, offering support on company practices and domain knowledge to ensure timely and successful project outcomes.",
		skills: [
			"Team Leadership",
			"Mentorship and Coaching",
			"Performance Management",
			"Domain Knowledge Sharing",
		],
		role: "Software Engineer, The Hut Group",
	},
	{
		title: "Yoti ID Verification",
		description:
			"Integrated Yoti’s ID verification API into Preloved’s platform using ColdFusion, enhancing the existing manual process. This upgrade provided users with a quick and seamless authentication method, enabling them to access the platform's features earlier. Additionally, it reduced the workload for the customer service team by automating member verification.",
		skills: [
			"API Integration (Yoti)",
			"ColdFusion",
			"Workflow Optimization",
			"Platform Security Enhancements",
		],
		role: "Graduate Software Engineer, The Hut Group",
	},
	{
		title: "Boost Membership Launch",
		description:
			"Developed the ‘Boost’ membership tier for Preloved from the ground up, using a ColdFusion backend. Designed and implemented the frontend for three components with ColdFusion, React, and Handlebars, and updated the database to support and monitor the new membership. Additionally, implemented tracking for conversions and user engagement by creating custom tags in Google Tag Manager and integrating them with Google Analytics.",
		skills: [
			"Frontend Development",
			"Google Tag Manager",
			"Google Analytics",
			"Database Management",
			"Membership Tier Development",
			"Conversion Tracking",
		],
		role: "Graduate Software Engineer, The Hut Group",
	},
	{
		title: "Dealer Lookup Integration",
		description:
			"Integrated the front and backend of the Bidex dealership lookup service for Endura's German site using Java, collaborating with multiple teams across THG to ensure full functionality and availability for applicable products. Implemented modifiable content parameters to enable easy activation of the service for other sites and countries with configurable content.",
		skills: [
			"Java",
			"Backend Development",
			"Frontend Integration",
			"Internationalization",
			"Multi-Team Collaboration",
		],
		role: "Graduate Software Engineer, The Hut Group",
	},
	{
		title: "Documentation Enhancement",
		description:
			"Led the enhancement of documentation for Preloved by using Confluence to thoroughly document and share domain knowledge. Streamlined the process for capturing new insights and changes, ensuring up-to-date documentation. Additionally, created multiple templates for Jira to improve ticket creation and task details for better clarity and efficiency.",
		skills: [
			"Confluence",
			"Jira",
			"Knowledge Sharing",
			"Process Documentation",
			"Collaboration",
		],
		role: "Graduate Software Engineer, The Hut Group",
	},
];
